const SITE_URL = "https://www.recoverycompassnh.com";

export const SITE_TITLE = "Recovery Compass NH";
export const siteUrl = SITE_URL;

export const articleCategoryConfig = {
  "unsung-heroes": {
    slug: "unsung-heroes",
    label: "Unsung Heroes",
    shortLabel: "Unsung Heroes",
  },
  "stories-of-recovery": {
    slug: "stories-of-recovery",
    label: "Stories of Recovery",
    shortLabel: "Recovery Stories",
  },
  "blog-posts": {
    slug: "blog-posts",
    label: "Blog Posts",
    shortLabel: "Blog",
  },
};

export const resourceCategoryConfig = {
  Housing: {
    slug: "housing",
    label: "Housing",
  },
  "Primary SUD Providers": {
    slug: "treatment-centers",
    label: "Primary SUD Providers",
  },
  "Primary Mental Health Providers": {
    slug: "mental-health-providers",
    label: "Primary Mental Health Providers",
  },
  Therapists: {
    slug: "therapists",
    label: "Therapists",
  },
  "Ride Services": {
    slug: "ride-services",
    label: "Ride Services",
  },
  "Crisis Intervention Services": {
    slug: "crisis-services",
    label: "Crisis Intervention Services",
  },
  "Online Resources and Support Groups": {
    slug: "support-groups",
    label: "Online Resources and Support Groups",
  },
};

export const faqSections = {
  resources: [
    {
      question: "Where can I find addiction treatment centers in New Hampshire?",
      answer:
        "Recovery Compass NH provides a comprehensive directory of verified treatment centers across all 10 New Hampshire counties, including detox facilities, MAT clinics, residential treatment, and outpatient programs. Filter by county and category to find resources near you.",
    },
    {
      question: "What crisis resources are available for substance use in NH?",
      answer:
        "Call 988 for the Suicide & Crisis Lifeline, 833-710-6477 for NH Rapid Response Access Point, or dial 2-1-1 for 24/7 referrals to treatment, housing, food, and other services across New Hampshire.",
    },
    {
      question: "Are there free recovery resources in New Hampshire?",
      answer:
        "Yes. Many resources listed on Recovery Compass NH are free or sliding-scale, including peer support centers, recovery community organizations, SMART Recovery meetings, AA and NA groups, and crisis hotlines.",
    },
    {
      question: "How do I find recovery housing or sober living in NH?",
      answer:
        "The directory includes recovery housing, sober living homes, and transitional housing options across New Hampshire. Filter by the Housing category and your county to find options near you.",
    },
  ],
  veterans: [
    {
      question: "What veteran resources are available in New Hampshire?",
      answer:
        "New Hampshire offers VA healthcare through Manchester VA, state veterans services through DMAVS, housing assistance through SSVF programs, employment services, crisis support via the Veterans Crisis Line, and benefits counseling through Veterans Services Officers.",
    },
    {
      question: "How do I access VA healthcare in New Hampshire?",
      answer:
        "Contact the VA Manchester Healthcare System at (603) 624-4366 or visit 718 Smyth Rd, Manchester, NH 03104. They offer primary and specialty care, mental health services, substance use treatment, and women veterans health services.",
    },
    {
      question: "What crisis resources exist for veterans in NH?",
      answer:
        "Veterans can call the Veterans Crisis Line by dialing 988 and pressing 1, text 838255, or chat online. The National Call Center for Homeless Veterans is available 24/7 at 1-877-424-3838.",
    },
    {
      question: "How can veterans get help with housing in New Hampshire?",
      answer:
        "Harbor Care Veterans FIRST provides SSVF homelessness prevention and rapid rehousing statewide. Veterans Inc. offers emergency and transitional housing support, and the VA Home Loan Guaranty program helps with home purchases.",
    },
  ],
};

export function slugify(value) {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getArticleCategoryBySlug(slug) {
  return Object.values(articleCategoryConfig).find((item) => item.slug === slug);
}

export function getArticleCategoryUrl(category) {
  const config = articleCategoryConfig[category];
  return config ? `/articles/category/${config.slug}` : "/articles";
}

export function getResourceCategoryBySlug(slug) {
  return Object.values(resourceCategoryConfig).find((item) => item.slug === slug);
}

export function getResourceCategoryUrl(category) {
  const config = resourceCategoryConfig[category];
  return config ? `/resources/category/${config.slug}` : "/resources";
}

export function getCountySlug(county) {
  return slugify(String(county || "").replace(/ County$/i, ""));
}

export function getCountyFromSlug(slug, counties) {
  return (counties || []).find(
    (county) => county !== "All" && getCountySlug(county) === slug
  );
}

export function getResourceCountyUrl(county) {
  return `/resources/county/${getCountySlug(county)}`;
}

export function getResourceCategoryCountyUrl(category, county) {
  return `${getResourceCategoryUrl(category)}/county/${getCountySlug(county)}`;
}

export function toAbsoluteUrl(path) {
  return path.startsWith("http") ? path : `${SITE_URL}${path}`;
}
